export default {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size',
    account: 'учетная запись',
    businessUsers: 'Бизнес-пользователи',
    userName: 'имя пользователя',
    currentRole: 'текущая роль',
    personalInformation: 'Личная информация',
    changePassword: 'изменить пароль',
    tip_notChangePassword: 'Совет: Текущая учетная запись не может изменить пароль',
    department: 'отделение',
    mobileNumber: 'Телефонный номер',
    pleaseEnterPhoneNumber: 'Пожалуйста, введите номер телефона',
    oldPassword: 'Старый пароль',
    newPassword: 'новый пароль',
    confirmPassword: 'Подтвердить Пароль',
}